import { HttpProvider } from './../http/http';
import { Events, AlertController } from 'ionic-angular';
import { Market } from '@ionic-native/market';
import { AppVersion } from '@ionic-native/app-version';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class VersaoProvider {
  versaoAtual: string;
  packApp: string;

  constructor(public http: HttpClient,
    private alertCtrl: AlertController,
    private appVersion: AppVersion,
    private market: Market,
    public events: Events,
    private httpSrv: HttpProvider,
  ) { }

  async verificaVersao() {
    this.httpSrv.postApi('v1/verificaVersaoApp', '').then(e => {
      if (e.data[0] === false) return this.abreLoja()
    })
  }

  async abreLoja() {
    try {
      this.appVersion.getPackageName().then(
        appPack => {
          this.packApp = appPack
          this.alertCtrl.create({
            title: 'Uma nova versão está disponível!',
            message: 'Por favor, atualize o aplicativo para a versão mais recente',
            enableBackdropDismiss: false,
            cssClass: 'alertUptadeApp',
            buttons: [
              {
                text: 'Atualizar',
                handler: () => {
                  this.market.open(this.packApp)
                }
              }
            ]
          }).present()
        },
        error => console.log(error)
      )
    }
    catch (error) {
      console.log(error)
    }
  }
} 



// WEBPACK FOOTER //
// ./src/providers/versao/versao.ts